import React from 'react';

export interface IIconProps {
	name: string;
}

/**
 * Icon
 * @block
 */
const Icon: React.FC<IIconProps> = ({ name }) => (
	<i className={`icon icon-${name}`} />
);

export default Icon;
